import * as Utils from '@ext/index';



export class Personas {

    constructor( id: string, descripcion: string ) {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): Personas {

        if ( id === this.Fisica.Id )
            return this.Fisica;
        else if ( id === this.Juridica.Id )
            return this.Juridica;

        return new Personas( id, id );
    }

    public static readonly Fisica: Personas = new Personas( 'fisica', 'Fisica' );
    public static readonly Juridica: Personas = new Personas( 'juridica', 'Juridica' );

    public static Options: Array<Personas> = [
        Personas.Fisica,
        Personas.Juridica
    ];

    public get esFisica(): boolean {
        return this.Id == Personas.Fisica.Id;
    }

    public get esJuridica(): boolean {
        return this.Id == Personas.Juridica.Id;
    }
}

export class Condiciones {

    constructor( id: number, descripcion: string ) {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: number;
    public readonly Descripcion: string;

    public static toTipo( id: number ): Condiciones {

        if ( id === this.ResponsableInscripto.Id )
            return this.ResponsableInscripto;
        else if ( id === this.ResponsableNoInscripto.Id )
            return this.ResponsableNoInscripto;
        else if ( id === this.Exento.Id )
            return this.Exento;
        else if ( id === this.ConsumidorFinal.Id )
            return this.ConsumidorFinal;
        else if ( id === this.NoInscripto.Id )
            return this.NoInscripto;
        else if ( id === this.ExportacionImportacion.Id )
            return this.ExportacionImportacion;
        else if ( id === this.SujetoNoObligado.Id )
            return this.SujetoNoObligado;
        else if ( id === this.Monotributo.Id )
            return this.Monotributo;

        return new Condiciones( id, id.toString() );
    }

    public static readonly ResponsableInscripto: Condiciones = new Condiciones( 1, 'Responsable inscripto' );
    public static readonly ResponsableNoInscripto: Condiciones = new Condiciones( 2, 'Responsable no inscripto' );
    public static readonly Exento: Condiciones = new Condiciones( 3, 'Exento' );
    public static readonly ConsumidorFinal: Condiciones = new Condiciones( 4, 'Consumidor final' );
    public static readonly NoInscripto: Condiciones = new Condiciones( 5, 'No inscripto' );
    public static readonly ExportacionImportacion: Condiciones = new Condiciones( 6, 'Exportacion/Importacion' );
    public static readonly SujetoNoObligado: Condiciones = new Condiciones( 7, 'Sujeto no obligado' );
    public static readonly Monotributo: Condiciones = new Condiciones( 8, 'Monotributo' );

    public static Options: Array<Condiciones> = [
        Condiciones.ResponsableInscripto,
        Condiciones.ResponsableNoInscripto,
        Condiciones.Exento,
        Condiciones.ConsumidorFinal,
        Condiciones.NoInscripto,
        Condiciones.ExportacionImportacion,
        Condiciones.SujetoNoObligado,
        Condiciones.Monotributo,
    ];

    public get esResponsableInscripto(): boolean {
        return this.Id == Condiciones.ResponsableInscripto.Id;
    }

    public get esConsumidorFinal(): boolean {
        return this.Id == Condiciones.ConsumidorFinal.Id;
    }

    public get esMonotributo(): boolean {
        return this.Id == Condiciones.Monotributo.Id;
    }

    public get FacturaA(): boolean {
        return this.esResponsableInscripto;
    }

    public get FacturaB(): boolean {
        return this.esConsumidorFinal;
    }

}